export default __webpack_public_path__ + "static/media/thankyou.1ca3af51.gif";